// extracted by mini-css-extract-plugin
export var scrollArea = "_oa-0";